const name = 'BlurIn';
const properties = { schema: {} };
const blurMap = {
    soft: 6,
    medium: 25,
    hard: 50,
};
function animate(kit, elements, duration, delay, { power, blur = 6, easing = 'linear', ...params } = {}) {
    const sequence = kit.sequence(params);
    const blurFactor = typeof power !== 'undefined' ? blurMap[power] : blur;
    sequence.add([
        kit.animate('BaseFade', elements, duration * 0.7, delay, {
            from: { opacity: 0 },
            to: { opacity: 1 },
            ease: 'sineIn',
        }),
        kit.animate('BaseFilter', elements, duration, delay, {
            from: {
                filter: `blur(${blurFactor}px)`,
            },
            to: {
                filter: `blur(0px)`,
            },
            ease: easing,
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=blurIn.js.map